import { render } from "./LoginForm.vue?vue&type=template&id=47227bac&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=47227bac&lang=css"
import "./LoginForm.vue?vue&type=style&index=1&id=47227bac&scoped=true&lang=css"

import exportComponent from "F:\\xampp\\htdocs\\HAVELI\\havelidashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47227bac"]])

export default __exports__